import { Modal } from "antd";

import { Button } from "components/Button";
import { formatDateHandler2 } from "utils/common";
import ExpiryBadge from "views/pages/Documents/components/ExpiryBadge";

// Shown when a new document is being added and the employee already has an
// active document of the same type (a renewed Emirates ID, visa...). The
// usual answer is to archive the old one, so that is the primary action;
// keeping both stays possible.
const DuplicateDocumentPrompt = ({ prompt, onCancel, onKeepBoth, onArchiveExisting }) => {
  const existing = prompt?.existing || [];
  const first = existing[0];
  const employee = first?.company_user;
  const typeName = first?.document_type?.name || "document";
  const who = employee ? `${employee.first_name || ""} ${employee.last_name || ""}`.trim() : "This employee";

  return (
    <Modal
      open={Boolean(prompt)}
      onCancel={onCancel}
      title={`Active ${typeName} already on file`}
      footer={null}
      zIndex={1300}
      width={520}
    >
      <p style={{ fontSize: "13px", color: "#374151", marginBottom: "12px" }}>
        {who} already has {existing.length === 1 ? "an active" : `${existing.length} active`} {typeName}
        {existing.length === 1 ? "" : " documents"}. A renewed document usually replaces the old one, so you can
        archive {existing.length === 1 ? "it" : "them"} now. Archived documents stay on record and can be restored.
      </p>
      <ul style={{ listStyle: "none", padding: 0, margin: "0 0 16px 0", display: "flex", flexDirection: "column", gap: "8px" }}>
        {existing.map((doc) => (
          <li
            key={doc.id}
            style={{ border: "1px solid #e5e7eb", borderRadius: "6px", padding: "10px 12px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", flexWrap: "wrap" }}
          >
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: "13px", fontWeight: 600, color: "#1f2937" }}>{doc.name || typeName}</div>
              <div style={{ fontSize: "12px", color: "#6b7280" }}>
                {doc.document_number ? `No. ${doc.document_number} · ` : ""}
                {doc.expiry_date ? `Expires ${formatDateHandler2(doc.expiry_date)}` : "No expiry date"}
              </div>
            </div>
            <ExpiryBadge document={doc} />
          </li>
        ))}
      </ul>
      <div className="d-flex justify-content-end flex-wrap" style={{ gap: "8px" }}>
        <Button label="Cancel" onClick={onCancel} className="btn btn-link" style={{ color: "#6b7280", fontWeight: 600 }} />
        <Button label="Keep both" onClick={onKeepBoth} className="btn btn-outline-secondary" style={{ borderRadius: "8px" }} />
        <Button
          label={existing.length === 1 ? "Archive existing & save" : "Archive all & save"}
          onClick={onArchiveExisting}
          className="btn btn-primary"
          style={{ borderRadius: "8px" }}
        />
      </div>
    </Modal>
  );
};

export default DuplicateDocumentPrompt;
